// extracted by mini-css-extract-plugin
module.exports = {"container":"about_container__TrWoI","list":"about_list__1bVLH"};